module.exports = "/_next/static/images/linkaja-91dcae036eb6295889dc7f4498031ce7.png";